import(/* webpackMode: "eager" */ "/vercel/path0/app/lorem-generator/page.tsx");
